import React, {useEffect, useState, useRef} from 'react';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {styled} from '@mui/system';

const StyledDataGrid = styled(DataGrid)(({theme}) => ({
    '& .MuiDataGrid-row': {
        '&:nth-child(even)': {
            backgroundColor: '#eaf0f5',
        },
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 'bold',
    },
    '& .MuiDataGrid-cell': {
        whiteSpace: 'normal !important',
        wordWrap: 'break-word',
    },
}));

function processData(data) {
    if (!data || !Array.isArray(data) || data.length === 0) return [];
    return data.map(row => ({
        id: row.value.id,
        ...row.value,
    }));
}

const RemovedBundlesLogGrid = ({data}) => {
    const gridRef = useRef(null);
    const [rows, setRows] = useState(processData(data));

    useEffect(() => {
        setRows(processData(data));
    }, [data]);

    // Only show columns defined in the model
    const columns = [
        { field: 'id', headerName: 'ID', width: 80 },
        { field: 'bundle', headerName: 'Bundle Name', width: 240 },
        { field: 'adt_company_id', headerName: 'ADT Company ID', width: 150 },
        { field: 'list_type', headerName: 'List Type', width: 140 },
        { field: 'list_id', headerName: 'List ID', width: 140 },
        { field: 'removed_at', headerName: 'Removed At', width: 180 },
    ];

    if (!data || data.length === 0) {
        return null;
    }

    return (
        <div style={{height: 800, width: '100%'}} ref={gridRef}>
            <StyledDataGrid
                rows={rows}
                columns={columns}
                pageSize={25}
                slots={{ toolbar: GridToolbar }}
                disableRowSelectionOnClick
            />
        </div>
    );
};

export default RemovedBundlesLogGrid;
